import { render, staticRenderFns } from "./Tuition.vue?vue&type=template&id=4116f9c5&"
import script from "./Tuition.vue?vue&type=script&lang=js&"
export * from "./Tuition.vue?vue&type=script&lang=js&"
import style0 from "./Tuition.vue?vue&type=style&index=0&id=4116f9c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports